export default __webpack_public_path__ + "static/media/Lydia 9781408333976.5ce50d65.jpg";